const styles = theme => ({
  //!
  showingsDetailLogo: {
    width: '80px',
    color: '#fff',
    position: 'relative',
    top: '4px'
  },

  // !
  showingsDetailApp: {
    height: '100vh',
    text: 'center',
    display: 'flex',
    flex: 'column',
    /* overflow: scroll, */
    /* position: fixed, */
    width: '100vw',
    background: 'rgba(245, 245, 245, 1)'
  },

  //!
  showingsDetailMenu: {
    /* position: absolute, */
    top: '0',
    left: '0',
    /* margin: 16px 0 0 16px, */
    margin: '16px 16px',
    color: '#fff'
  },

  //!
  showingsDetailHeader: {
    height: '8vh',
    background: 'rgba(237, 67, 106, 1)',
    display: 'flex',
    justify: 'space-between',
    align: 'center',
    flex: 'row',
    padding: '0px 0px'
  },

  // !
  showingsDetailLicense: {
    padding: '10px',
    margin: '0px'
  },

  // !
  showingsDoneButtonsWrapper: {
    display: 'flex',
    justify: 'flex-end',
    /* align center, */
    flex: 'row',
    padding: '10px 0px',
    width: '90vw'
  },

  showingsDoneButtons: {
    display: 'flex',
    justify: 'flex-end',
    flex: 'row',
    padding: '10px'
  }
})

export default styles
